import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';
import {
  CvSectionLink,
  CvSectionLinkResponse,
  UpdateCvSectionLinkRequest,
} from '@/../gen';

export const namespace = 'cvSectionLinkEdit';
const actionCreator = actionCreatorFactory(namespace);
export const GetCvSectionLink = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
}>('GET_CV_SECTION_LINK');
export const SetCvSectionLink = actionCreator<CvSectionLinkResponse>(
  'SET_CV_SECTION_LINK'
);
export const UpdateCvSectionLink = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
  body: UpdateCvSectionLinkRequest;
}>('UPDATE_CV_SECTION_LINK');
export const DeleteCvSectionLink = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
}>('DELETE_CV_SECTION_LINK');
export const ResetState = actionCreator<null>('RESET_STATE');

export interface State {
  cvSectionLink: CvSectionLink;
}

const initialState = (): State => {
  return { cvSectionLink: null };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(GetCvSectionLink, async function(context, action) {
      const { data } = await this.proffApi.getCvSectionLink(
        action.payload.params.cv_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionLink(data.data));
    }),
    action(UpdateCvSectionLink, async function(context, action) {
      const { data } = await this.proffApi.updateCvSectionLink(
        action.payload.params.cv_id,
        action.payload.params.id,
        action.payload.body
      );
      context.commit(SetCvSectionLink(data.data));
    }),
    action(DeleteCvSectionLink, async function(context, action) {
      await this.proffApi.deleteCvSectionLink(
        action.payload.params.cv_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionLink(null));
    }),
    action(ResetState, function(context, action) {
      context.commit(ResetState(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(SetCvSectionLink, (state, action) => {
      state.cvSectionLink = action.payload?.attributes;
    }),
    mutation(ResetState, state => {
      Object.assign(state, initialState());
    })
  ),
  getters: {
    cvSectionLink: state => state.cvSectionLink,
  },
};
